module.exports = __webpack_public_path__ + "static/media/texting-green.3e76cfe0.svg";